<template>
    <div class="mb-4 version_registry" style="justify-content:space-between">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item">
                    <a :href=route_back>Реестр версий</a>
                </li>
                <li class="breadcrumb-item active" aria-current="page">Добавить версию</li>
            </ol>
        </nav>
    </div>

    <div class="version_registry__input">
        <div class="mb-4">
            <div class="form-label">Клиент <span class="color-red">*</span></div>
            <v-select class="select"
                v-model="client"
                :items="clients"
                @update:modelValue="onChangeClient"
                @update:menu="$removeFocus"
                @click:clear="$removeFocus"
                @click:control="$removeFocus"
                item-title="name"
                item-value="id"
                variant="outlined"
                color="primary"
                density="compact"
                clearable>
                <template #no-data>
                    <v-list-item>
                        <span>Данные не найдены</span>
                    </v-list-item>
                </template>
            </v-select>
        </div>

        <div class="mb-4">
            <div class="form-label">Бренд <span class="color-red">*</span></div>
            <v-select class="select"
                :disabled="!client"
                v-model="brand"
                :items="brands"
                item-title="name"
                item-value="id"
                variant="outlined"
                color="primary"
                density="compact"
                clearable
                @update:menu="$removeFocus"
                @click:clear="$removeFocus"
                @click:control="$removeFocus">
                <template #no-data>
                    <v-list-item>
                        <span>Данные не найдены</span>
                    </v-list-item>
                </template>
            </v-select>
        </div>

        <div class="mb-4">
            <div class="form-label">Тип устройства <span class="color-red">*</span></div>
            <v-select class="select"
                      v-model="deviceType"
                      :items="deviceTypes"
                      item-title="name"
                      item-value="id"
                      variant="outlined"
                      color="primary"
                      density="compact"
                      clearable
                      @update:menu="$removeFocus"
                      @click:clear="$removeFocus"
                      @click:control="$removeFocus">
                <template #no-data>
                    <v-list-item>
                        <span>Данные не найдены</span>
                    </v-list-item>
                </template>
            </v-select>
        </div>

        <div class="mb-4">
            <div class="form-label">Тип обновления <span class="color-red">*</span></div>
            <v-select class="select"
                      v-model="deviceSoftwareType"
                      :items="deviceSoftwareTypes"
                      item-title="name"
                      item-value="id"
                      variant="outlined"
                      color="primary"
                      density="compact"
                      clearable
                      @update:menu="$removeFocus"
                      @click:clear="$removeFocus"
                      @click:control="$removeFocus">
                <template #no-data>
                    <v-list-item>
                        <span>Данные не найдены</span>
                    </v-list-item>
                </template>
            </v-select>
        </div>

        <div class="mb-4">
            <div class="form-label">Операционная система <span class="color-red">*</span></div>
            <v-select class="select"
                      v-model="deviceOperatingSystem"
                      :items="deviceOperatingSystems"
                      item-title="name"
                      item-value="id"
                      variant="outlined"
                      color="primary"
                      density="compact"
                      clearable
                      @update:menu="$removeFocus"
                      @click:clear="$removeFocus"
                      @click:control="$removeFocus">
                <template #no-data>
                    <v-list-item>
                        <span>Данные не найдены</span>
                    </v-list-item>
                </template>
            </v-select>
        </div>

        <div v-if="showInputVersionType" class="mb-4">
            <div class="form-label">Тип версии <span class="color-red">*</span></div>
            <v-select class="select"
                      v-model="versionType"
                      :items="versionTypes"
                      @update:menu="$removeFocus"
                      @click:clear="$removeFocus"
                      @click:control="$removeFocus"
                      item-title="name"
                      item-value="id"
                      variant="outlined"
                      color="primary"
                      density="compact"
                      clearable>
            </v-select>
        </div>

        <div v-if="showInputVersions" class="mb-4">
            <div class="form-label">Версия <span class="color-red">*</span></div>
            <v-select class="select"
                      v-model="versionNumberId"
                      :items="versions"
                      @update:menu="$removeFocus"
                      @click:clear="$removeFocus"
                      @click:control="$removeFocus"
                      item-title="full_version"
                      item-value="id"
                      variant="outlined"
                      color="primary"
                      density="compact"
                      clearable>
            </v-select>
        </div>

        <div class="mb-4">
            <file-upload-element
                @fileUpload="versionFileUpload"
                :label="'Загрузка установочного файла'"
                :label-required="true"
                :multiple_property="false"
                :fileExtension="'.sh'"
            />
        </div>

        <div class="mb-4">
            <label class="form-label">Описание <span class="color-red">*</span></label>
            <textarea v-model="description" cols="30" rows="5" minlength="10" class="form-control" placeholder="Введите описание версии" required></textarea>
        </div>

        <div class="form-check mb-4">
            <label for="create-required-version" class="form-check-label">
                <span>Обязательная версия</span>
                <input id="create-required-version" class="form-check-input" type="checkbox" v-model="isRequired">
            </label>
        </div>

        <div v-if="!isRequired" class="mb-4">
            <label class="form-label">
                Дата
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <title>Дата, до которой (включительно), необязательная версия будет актуальна для установки.</title>
                    <path d="M10 7.5H10.0083M9.16667 10H10V13.3333H10.8333M2.5 10C2.5 10.9849 2.69399 11.9602 3.0709 12.8701C3.44781 13.7801 4.00026 14.6069 4.6967 15.3033C5.39314 15.9997 6.21993 16.5522 7.12987 16.9291C8.03982 17.306 9.01509 17.5 10 17.5C10.9849 17.5 11.9602 17.306 12.8701 16.9291C13.7801 16.5522 14.6069 15.9997 15.3033 15.3033C15.9997 14.6069 16.5522 13.7801 16.9291 12.8701C17.306 11.9602 17.5 10.9849 17.5 10C17.5 8.01088 16.7098 6.10322 15.3033 4.6967C13.8968 3.29018 11.9891 2.5 10 2.5C8.01088 2.5 6.10322 3.29018 4.6967 4.6967C3.29018 6.10322 2.5 8.01088 2.5 10Z" stroke="#E33535" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </label>

            <input v-model="expiration" type="date" :min="now_date" class="form-control" required>
        </div>

        <div class="version_registry__buttons">
            <ConfirmBtn :class="'btn btn-lg btn-primary'" :text="'Сохранить'" @btnClick="save"/>
            <a :href="route_back" type="button" class="btn btn-lg btn-outline-dark">Отменить</a>
        </div>
    </div>

    <Alert />
</template>

<script>
import { mask } from "vue-the-mask";
import FileUploadElement from "../../../../elements/FileUploadElement.vue";
import axios from 'axios';
import DeviceSoftwareVersion from '../../../../models/AutomaticUpdateDevices/DeviceSoftwareVersion';
import Alert from "../../../alerts/Alert.vue";
import { mapMutations, mapState } from "vuex/dist/vuex.cjs.js";
import {el} from "vuetify/locale";
import ConfirmBtn from "../../../../elements/ConfirmBtn.vue";

export default {
    name: 'VersionAddComponent',
    components: {
        Alert,
        FileUploadElement,
        ConfirmBtn
    },
    props: {
        route_create: String,
        route_back: String,
        route_brands: String,
        route_clients: String,
        route_device_types: String,
        route_operating_systems: String,
        route_get_last_number_by_filter: String,
        route_release_versions_search: String,
        route_version_types: String,
        route_device_software_types: String,
        now_date: String,
        device_version_major: Object
    },
    directives: { mask },
    data() {
        return {
            version: new DeviceSoftwareVersion({
                route_create: this.route_create,
                route_client_search: this.route_clients,
                route_device_types_search: this.route_device_types,
                route_brand_search: this.route_brands,
            }),

            versionType: null,
            versionTypes: [],

            versions: [],
            versionNumberId: null,
            versionLast: null,
            showInputVersions: false,
            showInputVersionType: false,

            expiration: '',

            description: '',

            deviceType: null,
            deviceTypes: [],

            deviceSoftwareType: null,
            deviceSoftwareTypes: [],

            client: null,
            clients: [],

            brand: null,
            brands: [],

            deviceOperatingSystem: null,
            deviceOperatingSystems: [],

            notification: false,

            isRequired: true,

            alertMessage: '',

            files: [],
        }
    },
    computed: {
        ...mapState('fileUploader', ['fileList']),
    },
    watch: {
        client() {
            this.checkAndFetch();
        },
        brand() {
            this.checkAndFetch();
        },
        deviceType() {
            this.checkAndFetch();
        },
        deviceOperatingSystem() {
            this.checkAndFetch();
        },
        versionType() {
            if (this.versionType === this.device_version_major.id) {
                this.versionNumberId = null;
                this.showInputVersions = false;
            } else {
                this.getVersions();
                this.versionNumberId = null;
                this.showInputVersions = true;
            }
            if (this.versionType === null) {
                this.versionNumberId = null;
                this.showInputVersions = false;
            }
        }
    },
    methods: {
        ...mapMutations('alerts', ['addAlert']),
        ...mapMutations('ui', ['toggleLoading']),
        checkAndFetch() {
            if (this.client && this.brand && this.deviceType && this.deviceOperatingSystem) {
                this.getLastVersionNumber();
            }
        },
        getLastVersionNumber: async function () {
            let response = await axios.get(this.route_get_last_number_by_filter, {
                params: {
                    client_id: this.client,
                    brand_id: this.brand,
                    device_type_id: this.deviceType,
                    device_software_type_id: this.deviceSoftwareType,
                    device_operating_system_id: this.deviceOperatingSystem,
                }
            });
            this.versionLast = response.data.data;
            if (this.versionLast === null) this.versionType = this.device_version_major.id;
            await this.showInputVersionsTypes();
        },
        getVersions: async function () {
            let response = await axios.get(this.route_release_versions_search, {
                params: {
                    client_id: this.client,
                    brand_id: this.brand,
                    device_type_id: this.deviceType,
                    device_operating_system_id: this.deviceOperatingSystem,
                    device_version_type_id: this.versionType,
                    device_software_type_id: this.deviceSoftwareType
                }
            });
            this.versions = response.data.data;
        },
        getBrands: async function (clientId) {
            let brands = await this.version.brands({
                client_id: clientId
            });
            this.brands = brands.items;
        },
        getClients: async function () {
            let clients = await this.version.clients();
            this.clients = clients.items;
        },
        getDeviceTypes: async function() {
            let deviceTypes = await this.version.deviceTypes();
            this.deviceTypes = deviceTypes.items;
        },
        getDeviceOperatingSystems: async function () {
            const response = await axios.get(this.route_operating_systems);
            this.deviceOperatingSystems = response.data.data;
        },
        getDeviceSoftwareTypes: async function () {
            const response = await axios.get(this.route_device_software_types);
            this.deviceSoftwareTypes = response.data.data;
        },
        getVersionsTypes: async function () {
            const response = await axios.get(this.route_version_types);
            this.versionTypes = response.data.data;
        },
        onChangeClient: async function(clientId) {
            await this.getBrands(clientId);
            this.brand = null;
        },
        showInputVersionsTypes: async function() {
            if (this.versionLast != null) {
                this.showInputVersionType = true;
                this.versionType = null;
                this.versionNumberId = null;
                await this.getVersionsTypes();
            } else {
                this.showInputVersionType = false;
                this.showInputVersions = false;
            }
        },
        save: async function () {
            this.isButtonDisabled = true;
            if (this.client === null) {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Выберите клиента!' });
                this.toggleLoading();
                return;
            }

            if (this.brand === null) {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Выберите бренд!' });
                this.toggleLoading();
                return;
            }

            if (this.versionType === null && this.showInputVersionType) {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Укажите тип версии!' });
                this.toggleLoading();
                return;
            }

            if (this.versionNumberId === null && this.showInputVersions) {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Укажите версию!' });
                this.toggleLoading();
                return;
            }

            if (this.description === '' || this.description === null) {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Добавьте описание!' });
                this.toggleLoading();
                return;
            }

            if (this.description.length < 10) {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Слишком короткое описание. Минимальное количество символов не менее 10.' });
                this.toggleLoading();
                return;
            }

            if (this.deviceType === null) {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Выберите тип устройства!' });
                this.toggleLoading();
                return;
            }

            if (this.deviceSoftwareType === null) {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Выберите тип обновления!' });
                this.toggleLoading();
                return;
            }

			if (this.deviceOperatingSystem === null) {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Выберите операционную систему!' });
                this.toggleLoading();
                return;
            }

            if (!this.isRequired && this.expiration === '') {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Укажите дату до которой будет актуальна установка необязательной версии!' });
                this.toggleLoading();
                return;
            }

            if (!this.fileList.length) {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Загрузите установочный файл!' });
                this.toggleLoading();
                return;
            }

			let formData = new FormData();
            formData.append('client_id', this.client);
            formData.append('brand_id', this.brand);
            formData.append('device_type_id', this.deviceType);
            formData.append('device_software_type_id', this.deviceSoftwareType);
            formData.append('device_operating_system_id', this.deviceOperatingSystem);
            formData.append('device_version_type_id', this.versionType);
            formData.append('parent_version_id', this.versionNumberId ?? 0);

            this.files.forEach(file => {
                formData.append("files[]", file);
            });

            formData.append('description', this.description);
            formData.append('is_required', this.isRequired ? 1 : 0);
            formData.append('expiration_date', this.expiration);

            let response = await axios.post(this.route_create, formData);

            if (response.data) {
                window.location.href = this.route_back;
            } else {
                this.addAlert({ type: 'error', title: 'Ошибка', text: window.lastResponse.data.message });
                this.toggleLoading();
            }
        },
        versionFileUpload: function (e) {
            if (e) {
                this.files.push(e);
            }
        },
        interceptResponse() {
            window.lastResponse = null;
            axios.interceptors.response.use(response => {
                window.lastResponse = response;
                return response;
            }, error => {
                window.lastResponse = error.response;
                return Promise.reject(error);
            });
        },
    },
    mounted() {
		this.interceptResponse();
        this.getClients();
        this.getDeviceTypes();
        this.getDeviceOperatingSystems();
        this.getDeviceSoftwareTypes();
    }
};
</script>

<style scoped lang="scss">
.page-label {
    font-size: 18px;
    font-weight: 600;
}
.version_registry {
    &__input {
        display: flex;
        flex-direction: column;
        max-width: 400px;
        .version-input {
            display: flex;
            gap: 8px;
            justify-content: center;
            align-items: center;
            &__element {
                flex: 1;
            }
        }
    }
    &__buttons {
        display: flex;
        padding: 0;
        gap: 12px;
        .btn {
            flex-grow: 1;
        }
    }
}
.pointer {
    cursor: pointer;
}
.form-label {
    position: relative;
}
.info-btn {
    cursor: pointer;
}
.popup {
    display: none;
    padding: 16px;
    border-radius: 12px;
    position: absolute;
    z-index: 5;
    width: fit-content;
    height: fit-content;
    background-color: white;
    color: #A8A8A8;
    font-weight: 400;
    font-size: 13px;
    box-shadow: 0px 4px 16px 0px rgba(100, 100, 100, 0.2);
    transition: 0.2s;
    span {
        text-decoration: underline;
    }
    p {
        margin: 0px;
    }
}
.visible {
    display: block;
    transition: 0.2s;
}
</style>
